import { useAppSettingsService } from "src/services/appSettingsService/appSettingsService";

import { useEnrollmentFlowEnabled } from "./useEnrollmentFlowEnabled";
import { useHasEnrolledDevice } from "./useHasEnrolledDevice";

/**
 * Whether the navigation lists the Enrollment page. A workspace without any enrolled device sees it even when the
 * workspace setting hides it, so a new customer finds where to start.
 */
export function useShowEnrollmentInNavigation(): boolean {
    const { effectiveWorkspaceSettings } = useAppSettingsService();
    const isEnrollmentFlowEnabled = useEnrollmentFlowEnabled();
    const hasEnrolledDevice = useHasEnrolledDevice();

    return effectiveWorkspaceSettings.isEnrollmentPageEnabled || (isEnrollmentFlowEnabled && hasEnrolledDevice === false);
}
